// Slidercthumbnails Variantes Color - The Digital Thinking

let vtTooltip = null;

function vtShowTooltip(thumb) {
  const label = thumb.dataset.vtLabel;
  if (!label) return;

  if (!vtTooltip) {
    vtTooltip = document.createElement('div');
    vtTooltip.className = 'vt-tooltip';
    document.body.appendChild(vtTooltip);
  }

  vtTooltip.textContent = label;

  const rect = thumb.getBoundingClientRect();
  const scrollY = window.scrollY || window.pageYOffset;
  const scrollX = window.scrollX || window.pageXOffset;

  vtTooltip.style.left = scrollX + rect.left + rect.width / 2 + 'px';
  vtTooltip.style.top = scrollY + rect.top - 8 + 'px';
  vtTooltip.style.opacity = '1';
}

function vtHideTooltip() {
  if (!vtTooltip) return;
  vtTooltip.style.opacity = '0';
}

function vtSelectThumb(slider, thumb) {
  const thumbs = slider.querySelectorAll('.vt-thumb');
  thumbs.forEach((t) => t.classList.remove('is-active'));
  thumb.classList.add('is-active');

  const productUrl = slider.dataset.productUrl;
  const variantId = thumb.dataset.vtVariantId;
  const imgUrl = thumb.dataset.vtImage;
  const variantUrl =
    thumb.dataset.vtVariantUrl ||
    (productUrl && variantId ? productUrl + '?variant=' + variantId : null);

  if (!productUrl) return;

  // 1) Actualizar imagen principal de la card (sin recargar página)
  const card =
    slider.closest('[data-product-id]') ||
    slider.closest('.product-card') ||
    slider.closest('article') ||
    slider.closest('li');

  if (card && imgUrl) {
    // Buscamos el primer enlace al producto y su imagen
    const mainLink =
      card.querySelector('a[href^="' + productUrl + '"]') ||
      card.querySelector('a[href*="' + productUrl + '"]');

    if (mainLink) {
      const mainImg = mainLink.querySelector('img');
      if (mainImg) {
        mainImg.src = imgUrl;
        // Limpia srcset para evitar que el navegador insista en otras versiones
        if (mainImg.srcset) {
          mainImg.srcset = '';
        }
      }
    }
  }

  // 2) Actualizar todos los links de la card a la variante seleccionada
  if (card && variantUrl) {
    const links = card.querySelectorAll('a[href^="' + productUrl + '"]');
    links.forEach((link) => {
      link.href = variantUrl;
    });
  }
}

function initVariantThumbnailsSliders(root = document) {
  const sliders = root.querySelectorAll('[data-vt-slider]');
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    if (slider.dataset.vtInitialized === 'true') return;
    slider.dataset.vtInitialized = 'true';

    const track = slider.querySelector('.vt-track');
    const prev = slider.querySelector('.vt-arrow--prev');
    const next = slider.querySelector('.vt-arrow--next');

    if (!track) return;

    function updateArrows() {
      const hasScroll = track.scrollWidth > track.clientWidth + 1;
      slider.dataset.vtHasScroll = hasScroll ? 'true' : 'false';

      if (!hasScroll) return;

      const maxScroll = track.scrollWidth - track.clientWidth - 1;
      const current = track.scrollLeft;

      slider.dataset.vtAtStart = current <= 0 ? 'true' : 'false';
      slider.dataset.vtAtEnd = current >= maxScroll ? 'true' : 'false';
    }

    function scrollByAmount(direction) {
      const amount = track.clientWidth * 0.6;
      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', () => scrollByAmount(-1));
    if (next) next.addEventListener('click', () => scrollByAmount(1));

    track.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);

    // Eventos en thumbnails (click + tooltip)
    const thumbs = slider.querySelectorAll('.vt-thumb');

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        vtSelectThumb(slider, thumb);
        vtShowTooltip(thumb);
      });

      thumb.addEventListener('mouseenter', () => {
        vtShowTooltip(thumb);
      });

      thumb.addEventListener('mouseleave', () => {
        vtHideTooltip();
      });

      thumb.addEventListener('focus', () => {
        vtShowTooltip(thumb);
      });

      thumb.addEventListener('blur', () => {
        vtHideTooltip();
      });

      thumb.addEventListener(
        'touchstart',
        () => {
          vtSelectThumb(slider, thumb);
          vtShowTooltip(thumb);
        },
        { passive: true }
      );
    });

    updateArrows();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initVariantThumbnailsSliders(document);
});

document.addEventListener('shopify:section:load', (event) => {
  if (!event.target) return;
  initVariantThumbnailsSliders(event.target);
});